import { render, staticRenderFns } from "./ProfileCertSkeleton.vue?vue&type=template&id=b2813f6a&scoped=true"
import script from "./ProfileCertSkeleton.vue?vue&type=script&lang=js"
export * from "./ProfileCertSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2813f6a",
  null
  
)

export default component.exports